var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.811 1.2103C10.0923 0.929091 10.4738 0.771118 10.8715 0.771118C11.2692 0.771118 11.6507 0.929091 11.932 1.2103L13.7882 3.06655C13.9276 3.20584 14.0381 3.37123 14.1136 3.55326C14.189 3.73529 14.2278 3.93039 14.2278 4.12742C14.2278 4.32446 14.189 4.51956 14.1136 4.70159C14.0381 4.88362 13.9276 5.049 13.7882 5.1883L4.8685 14.108L0.0834961 14.915L0.891246 10.13L9.811 1.2103ZM9.63925 3.50305L11.4955 5.3593L12.7277 4.12705L10.8715 2.27155L9.63925 3.50305ZM10.4342 6.42055L8.57875 4.5643L2.29075 10.8523L1.9135 13.085L4.14625 12.7085L10.4342 6.42055Z",
    fill: "#59636E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b3a8aef90282bde095242bc96d372ffc.svg";
export { ForwardRef as ReactComponent };